
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/adobe-campaign-classic",
      function () {
        return require("private-next-pages/destinations/adobe-campaign-classic.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/adobe-campaign-classic"])
      });
    }
  